import { render, staticRenderFns } from "./MetricsStudents.vue?vue&type=template&id=cf06cb16&scoped=true&"
import script from "./MetricsStudents.vue?vue&type=script&lang=js&"
export * from "./MetricsStudents.vue?vue&type=script&lang=js&"
import style0 from "./MetricsStudents.vue?vue&type=style&index=0&id=cf06cb16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf06cb16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VDialog,VRow})
